module.exports = __webpack_public_path__ + "assets/img/course4.fca91729.png";